// src/components/molecules/shpw-up-to-free-shipping/index.js

export { default } from './ShowUpToFreeShipping';
